export default __webpack_public_path__ + "static/media/clear.b808a269.svg";